/**
 * Copy for routes that exist but are not built out yet.
 *
 * The thank-you pages used to live here. They are real pages now — see
 * `thankYou.ts` — and only the 404 remains.
 */

export const notFoundContent = {
  eyebrow: 'Not found',
  headline: "That page isn't here.",
  body: 'The link might be out of date, or the address might have a typo in it. Everything on the site is reachable from the homepage.',
  links: [
    { label: 'Homepage', to: '/' },
    { label: 'For horse owners', to: '/owners' },
    // "For service providers" is category language the voice rules put on the
    // never list. Flagged for the owner; "For providers" is the interim wording.
    { label: 'For providers', to: '/providers' },
  ],
} as const;
